import { render } from "./tagCreat.vue?vue&type=template&id=a884b0ae&scoped=true"
import script from "./tagCreat.vue?vue&type=script&lang=js"
export * from "./tagCreat.vue?vue&type=script&lang=js"

import "./tagCreat.vue?vue&type=style&index=0&id=a884b0ae&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a884b0ae"]])

export default __exports__